import React from 'react';
import { TextWrapper } from './RotationInfoPanel.styles';
import { useRotationStore } from '../../../context/RotationContext';
import { prettifyDateTime } from 'odfjell-date-time-utils/dateTimeFormatter';
import OdfjellPanel, { PANEL_CONSTANTS } from 'src/components/ui/odfjellPanel/OdfjellPanel';

type Props = {
    onOk: () => void;
    isOpen: boolean;
};

const RotationInfoPanelComponent: React.FC<Props> = (props) => {
    const { rotation } = useRotationStore();

    const getStowageName = () => {
        return <TextWrapper>Stowage plan: {rotation?.stowagePlanName}</TextWrapper>;
    };

    const getLastImosUpdate = () => {
        return <TextWrapper>Last IMOS update: {prettifyDateTime(rotation?.lastImosUpdatedUtc)}</TextWrapper>;
    };

    const getLastImosSync = () => {
        return <TextWrapper>Last master stowage plan synchronization: {prettifyDateTime(rotation?.lastImosSynchronizedUtc)}</TextWrapper>;
    };

    const onClosePanel = () => {
        props.onOk();
    };

    return (
        <>
            {props.isOpen && (
                <OdfjellPanel
                    headerTitle="Rotation information"
                    defaultPosition="center"
                    panelWidth={PANEL_CONSTANTS.MEDIUM_WIDTH}
                    onCancel={onClosePanel}
                    onAction={onClosePanel}
                    actionButtonText="Close"
                >
                    {getStowageName()}
                    {getLastImosUpdate()}
                    {getLastImosSync()}
                </OdfjellPanel>
            )}
        </>
    );
};

export default RotationInfoPanelComponent;
